// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
  const quantityPlus = document.querySelector(".quantity-plus");
  const quantityMinus = document.querySelector(".quantity-minus");
  const coffee = document.getElementById("coffeePrice");
  const product = document.querySelector(".product-single");
  
  function updateCoffeePrice(newQuantity, price = null) {
    const unitprice = coffee.dataset.price;

    if (!newQuantity || newQuantity == '') return;

    if (newQuantity > 0 && newQuantity ) {
      coffee.innerText = Shopify.formatMoney(
        unitprice * newQuantity,
        Shopify.money_format
      );
    }
  };

  function oldupdateCoffeePrice(newQuantity, price = null) {
    if (!product.dataset.applicableDiscounts) {
      return;
    }
    const discounts = JSON.parse(product.dataset.applicableDiscounts);
    
    const variant_name = coffee.dataset.variant;
    const orig_price = price ?? coffee.dataset.price;
    const orig_price_display = price ?? coffee.dataset.price;
    let discounted_price = orig_price * newQuantity;

    const fullPrice = orig_price * (newQuantity !== '' ? newQuantity : 1);

    const applicableDiscount = discounts.find(discount => {
      if (newQuantity > 0 && newQuantity < 5) {
        if (discount.minItems == newQuantity) {
          return true;
        }
      }
      else if (newQuantity > 4) {
        if (discount.minItems > 4) {
          return true;
        }
      }
    })

    let discountValue = applicableDiscount ? Math.floor(applicableDiscount.value * 100) : 0;

    if (applicableDiscount?.percentage) {
      const b = parseFloat(orig_price) * newQuantity;
      const rounded = Math.ceil(b / 10) * 10;

      const perc = 1 - parseFloat(applicableDiscount?.percentage);
      
      discounted_price = rounded * perc;
    }
    else {
      if (discountValue > 0) {
        discounted_price = fullPrice - discountValue;
      }
    }

    coffee.innerText = Shopify.formatMoney(
      discounted_price,
      Shopify.money_format
    );

    if (newQuantity > 1) {
      orig_price_display.innerText = Shopify.formatMoney(
        orig_price * newQuantity,
        Shopify.money_format
      );
    } else {
      orig_price_display.innerText = "";
    }
  }

  document.addEventListener(
    "sealsubs:subscription_widget_created",
    function () {
      setTimeout(() => {
        const subs_messages = document.createElement("div");
        let msg_string =
          "<a href='/pages/subscribe' class='block max-mdx:mt-5 text-[12px] font-poppins leading-tight' target='_blank'>No commitment, cancel any time!</a>";

        const deliveryString =
          "<p class='py-2 text-[12px] font-poppins leading-tight'><span class='text-red'>Save $7.50</span> with free delivery on subscriptions!</p>";
        msg_string += deliveryString;

        const sub_discount_msg =
          "<p class='text-[12px] font-poppins font-bold leading-tight'>2 item minimum for subscriptions.</p>";
        msg_string += sub_discount_msg;

        subs_messages.innerHTML = msg_string;

        const sub_label = document.querySelector(
          ".selling-plan-group-options-name-select"
        );
        sub_label.appendChild(subs_messages);
      }, 800);
    }
  );

  document.addEventListener("sealsubs:price_update", function (e) {
    const quantitySelector = document.querySelector("#quantity");
    coffee.dataset.price = e.detail.price;

    updateCoffeePrice(quantitySelector.value, e.detail.price);
  });

  quantityPlus?.addEventListener("click", () => {
    
    const currentQuantity = document.querySelector("#current-quantity");
    const quantitySelector = document.querySelector("#quantity");
    const newQuantity = parseInt(currentQuantity.innerText) + 1;

    currentQuantity.innerText = newQuantity;
    quantitySelector.value = newQuantity;

    if (coffee) {
      updateCoffeePrice(newQuantity);
    }
  });

  quantityMinus?.addEventListener("click", () => {
    const currentQuantity = document.querySelector("#current-quantity");
    const quantitySelector = document.querySelector("#quantity");
    const newQuantity = parseInt(currentQuantity.innerText) - 1;
    if (newQuantity > 0) {
      currentQuantity.innerText = newQuantity;
      quantitySelector.value = newQuantity;
    }

    if (coffee && newQuantity > 0) {
      updateCoffeePrice(newQuantity);
    }
  });

  document.querySelectorAll(".image-gallery").forEach((gallery) => {
    const slides = gallery.querySelectorAll(".image-gallery-slide");
    const prev = gallery.querySelector(".prev");
    const next = gallery.querySelector(".next");
    const track = gallery.querySelector(".image-gallery-track");

    const setNewSlide = (newIndex) => {
      const newSlide = slides[newIndex];
      newSlide.classList.add("active");
    };

    prev &&
      prev.addEventListener("click", () => {
        const current = gallery.querySelector(".image-gallery-slide.active");
        let newIndex;
        current.classList.remove("active");
        if (current.dataset.index == 0) {
          newIndex = slides.length - 1;
        } else {
          newIndex = parseInt(current.dataset.index) - 1;
        }
        setNewSlide(newIndex);
      });

    next &&
      next.addEventListener("click", () => {
        const current = gallery.querySelector(".image-gallery-slide.active");
        let newIndex;
        current.classList.remove("active");
        if (current.dataset.index == slides.length - 1) {
          newIndex = 0;
        } else {
          newIndex = parseInt(current.dataset.index) + 1;
        }
        setNewSlide(newIndex);
      });
  });
});
